import { capitalize } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Link } from 'gatsby';
import * as React from 'react';


export default function CategoryList({ items, baseUrl, icon }) {
    if (items && items.length > 0) {
        return (
            <Typography color="textSecondary" gutterBottom align='center' sx={{ textTransform: "capitalize" }}>
                {
                    items.map((category) =>
                    (
                        <span key={"categorykey" + category}>
                            {icon}
                            <Link to={`${baseUrl}/${category}`}>{category.replaceAll("-", " ")}</Link>
                        </span>
                    )
                    ).reduce((prev, curr) => [prev, ', ', curr])
                }
            </Typography>
        );
    } else {
        return <span data-msg="no category items" />
    }
}